exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NotificationsPopover-ca931480{width:600px;max-width:90vw}.scroll-33755c57{max-height:400px;overflow-y:auto}.header-5e2abcc4{height:40px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #E0E0E0;padding:0 10px}.header-5e2abcc4 a.action-aa2914a3{color:inherit;display:inline-block;margin:0 5px}.header-5e2abcc4 a.action-aa2914a3:last-child{margin-right:0}.light-afab450d{color:#757575}\n", ""]);

// Exports
exports.locals = {
	"NotificationsPopover": "NotificationsPopover-ca931480",
	"scroll": "scroll-33755c57",
	"header": "header-5e2abcc4",
	"action": "action-aa2914a3",
	"light": "light-afab450d"
};